import React from "react";
import { useSpring } from "react-spring";
import { useWindowSize } from "../../../../shared/hooks";
import CartControl from "../CartControl";
import * as S from "./styles";
export var ProductImage = function ProductImage(_ref) {
  var e = _ref.imageAlt,
      t = _ref.imageBackgroundColor,
      o = _ref.image,
      a = _ref.isHovering,
      r = _ref.addedToCart,
      c = _ref.removedFromCart,
      n = _ref.onAddToCartClick,
      m = _ref.onRemoveFromCartClick,
      l = _ref.isOnSale,
      _ref$isOutOfStock = _ref.isOutOfStock,
      d = _ref$isOutOfStock === void 0 ? !1 : _ref$isOutOfStock,
      _ref$isNew = _ref.isNew,
      i = _ref$isNew === void 0 ? !1 : _ref$isNew,
      _ref$showAddToCart = _ref.showAddToCart,
      s = _ref$showAddToCart === void 0 ? !0 : _ref$showAddToCart,
      C = _ref.tabIndex;

  var _useWindowSize = useWindowSize(),
      u = _useWindowSize.isMobile,
      g = "object" == typeof o,
      p = l && !i,
      f = !!s && !d,
      k = useSpring({
    transform: a ? "scale(1.125)" : "scale(1)"
  });

  return React.createElement(S.ImageWrapper, {
    "data-testid": "product-card-image"
  }, g ? React.createElement(S.AnimatedProductImageComponent, {
    alt: e,
    style: k,
    imageBackgroundColor: t
  }, o) : React.createElement(S.AnimatedProductImage, {
    alt: e,
    src: o,
    style: k,
    imageBackgroundColor: t
  }), f && React.createElement(S.CartControlWrapper, null, React.createElement(CartControl, {
    showIcon: a || u,
    addedToCart: r,
    removedFromCart: c,
    onAddClick: n,
    onRemoveClick: m,
    tabIndex: C
  })), i && React.createElement(S.NewIcon, null, "New"), p && React.createElement(S.SaleIcon, null, "Sale"), d && React.createElement(S.OutOfStock, {
    "data-testid": "out-of-stock"
  }, "Out of Stock"));
};
export default ProductImage;